// src/components/ProtectedRoute.js
import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("careToken");
  const isVerified = localStorage.getItem("isVerified");
  
  if (!token) {
    return <Navigate to="/" replace />;
  }
  
  if (!isVerified) {
    return <Navigate to="/verify-otp" replace />;
  }
  
  return children;
};
export const AuthRoute = ({ children }) => {
  const token = localStorage.getItem("careToken");
  const flowType = localStorage.getItem("flowType");

  if (token && flowType !== "forgot-password") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

// export const AuthRoute = ({ children }) => {
//   const token = localStorage.getItem("careToken");
  
//   if (token) {
//     return <Navigate to="/dashboard" replace />;
//   }
//   return children;
// };
// export const AuthRoute = ({ children }) => {
//   const token = localStorage.getItem("careToken");
//   const flowType = localStorage.getItem("flowType");

//   if (token && flowType !== "forgot-password") {
//     return <Navigate to="/dashboard" replace />;
//   }

//   return children;
// };


// import React from "react";
// import { Navigate } from "react-router-dom";

// const ProtectedRoute = ({ children }) => {
//   const careCred = JSON.parse(localStorage.getItem("careCred") || "{}");
//   const isAuthenticated = careCred && careCred.email;

//   if (!isAuthenticated) {
//     return <Navigate to="/" replace />;
//   }

//   return children;
// };

// export default ProtectedRoute;